"use strict";
import { Flex, TouchableArea } from "ui/src";
import { X } from "ui/src/components/icons/X";
export var PasskeyMenuModalState = /* @__PURE__ */ ((PasskeyMenuModalState2) => {
  PasskeyMenuModalState2["ADD_PASSKEY"] = "ADD_PASSKEY";
  PasskeyMenuModalState2["DELETE_PASSKEY"] = "DELETE_PASSKEY";
  PasskeyMenuModalState2["DELETE_PASSKEY_SPEEDBUMP"] = "DELETE_PASSKEY_SPEEDBUMP";
  PasskeyMenuModalState2["VERIFY_PASSKEY"] = "VERIFY_PASSKEY";
  return PasskeyMenuModalState2;
})(PasskeyMenuModalState || {});
export function GenericPasskeyMenuModal({
  show,
  onClose,
  children
}) {
  return <Flex
    display={show ? "flex" : "none"}
    position="absolute"
    top="50%"
    left="50%"
    transform="translate(-50%, -50%)"
    background="$surface1"
    opacity={1}
    borderRadius="$rounded20"
    pt={24}
    px="$padding16"
    pb="$padding16"
    gap="$gap16"
    alignItems="center"
    width="max-content"
    maxWidth={336}
    zIndex={2}
    onPress={(e) => {
      e.stopPropagation();
    }}
    $md={{
      position: "static",
      transform: "none",
      pt: 0,
      px: 0,
      width: "100%",
      maxWidth: "100%"
    }}
  ><Flex row width="100%" mb={-8} justifyContent="flex-end" $md={{ display: "none" }}><TouchableArea onPress={onClose}><X size={24} color="$neutral2" /></TouchableArea></Flex>{children}</Flex>;
}
